"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _ComponentRowDual = _interopRequireDefault(require("../ComponentRow/ComponentRowDual8020"));
var _ComponentRowSingle = _interopRequireDefault(require("../ComponentRow/ComponentRowSingle"));
require("./StreamingLayout.css");
var _withAuthentication = _interopRequireDefault(require("../../hocs/withAuthentication"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutClasses = (0, _cssClassesHelper.getBEMClasses)('streaming-layout');
var StreamingLayout = function StreamingLayout(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('fixed-container')
  }, /*#__PURE__*/_react["default"].createElement(_ComponentRowDual["default"], {
    customClass: layoutClasses('top-row'),
    component1: props.component1,
    component2: props.component2
  }), /*#__PURE__*/_react["default"].createElement(_ComponentRowSingle["default"], {
    customClass: "".concat(layoutClasses('bottom-row'), " container-with-shadow"),
    component: props.component3
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('footer')
  }, props.footer));
};
var _default = exports["default"] = (0, _withAuthentication["default"])(StreamingLayout);